// This icon file is generated automatically.
// tslint:disable
var TreeCollapseFunc = { "name": "treeCollapse", "theme": "func", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M1024 258.56S531.2 768 513.28 768C495.36 768 0 256 0 256l1024 2.56z" } }] } };
export default TreeCollapseFunc;
